import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { ShipmentWaybillMaterialsFacade } from './shipment-waybill-materials.facade';
import { ShipmentWaybillMaterialListSearchCriteria } from '../../models/shipment-waybill-materials.model';

@Injectable({
  providedIn: 'root',
})
export class ShipmentWaybillMaterialsGuard {
  constructor(private shipmentWaybillMaterialsFacade: ShipmentWaybillMaterialsFacade) {}
  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.shipmentWaybillMaterialsFacade, new ShipmentWaybillMaterialListSearchCriteria());
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentWaybillMaterialsFacade);
  }
}
